// Grading periods by school year type (school_year.syType) — mirror
// GRADING_PERIODS in backend school-year-quarter.entity.ts.
const GRADING_PERIODS = {
  0: ['1st Quarter', '2nd Quarter', '3rd Quarter', '4th Quarter'],
  1: ['1st Term', '2nd Term', '3rd Term'],
};

export const gradingPeriods = (syType) => GRADING_PERIODS[Number(syType)] ?? GRADING_PERIODS[0];
